module.exports = __webpack_public_path__ + "img/saveWhite.e4b679fc.svg";